import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';

export class CampaignsCloneController {
  /* @ngInject */
  constructor($stateParams, $filter, $state, notify, CampaignsResource, $q) {
    this.translate = $filter('translate');
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.notify = notify;
    this.CampaignsResource = CampaignsResource;
    this.$q = $q;
    this.campaign = {};

    if ($stateParams.campaign) {
      this.campaign = $stateParams.campaign;
      this.cloneCampaign();
    } else {
      this.$state.go('app.campaigns.index');
    }
  }

  cloneCampaign() {
    let newCampaign = _.cloneDeep(this.campaign);
    delete newCampaign.id;
    delete newCampaign.created_at;
    delete newCampaign.updated_at;
    delete newCampaign.start_date;
    delete newCampaign.end_date;
    newCampaign.start_mode = 'immediate';
    newCampaign.end_mode = 'never';
    _.forEach(newCampaign.frequency_caps.impression, f => { f.level_entity_id = null; f.id = null });
    _.forEach(newCampaign.frequency_caps.rule, f => { f.level_entity_id = null; f.id = null });
    newCampaign.name = this.translate('copy_of') + ' ' + this.campaign.name;
    this.$state.go('app.campaigns.new', {
      type: this.campaign.type,
      gameId: this.campaign.game_id,
      campaign: newCampaign,
      cloning: true
    });
    this.notify.duplicated('campaign', newCampaign.name);
  }
}

export function CampaignsCloneComponent() {
  return {
    controller: CampaignsCloneController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.clone', [
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
.directive('campaignsClone', CampaignsCloneComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsClone.js
 **/